const StringMixin = {
  sentenceCase(string) {
    return string[0].toUpperCase() + string.slice(1).toLowerCase();
  }
}

export default StringMixin;
